<template>
  <GamingButtonValueIcon :value="gaming.xp">
    <template #icon>
      <LogoXP />
    </template>
  </GamingButtonValueIcon>
</template>
<script setup lang="ts">
const gaming = useGamingStore();
</script>
